import { ScoutingPhoto,ScoutingPhotoCategory } from '../types';
import { ScoutingPhotoFilters } from './scoutingClient';

type LegacyCategoryPhoto = Pick<ScoutingPhoto, 'tag_category_ids'> & { category_id?: string | null };
export const isAdminOnlyPhotoCategory=(category:ScoutingPhotoCategory)=>category.admin_only===true||['loginbackground','unauth-background'].includes(category.name.trim().toLowerCase());

const normalizeCategoryIds = (categoryIds: Array<string | null | undefined>): string[] => {
  return Array.from(new Set(categoryIds.filter((categoryId): categoryId is string => Boolean(categoryId))));
};

export const getEffectivePhotoCategoryIds = (photo: LegacyCategoryPhoto): string[] => {
  return normalizeCategoryIds([...(photo.tag_category_ids || []), photo.category_id]);
};

export const getEffectiveFilterCategoryIds = (
  filters: Pick<ScoutingPhotoFilters, 'categoryId' | 'tagCategoryIds'>,
): string[] => {
  return normalizeCategoryIds([filters.categoryId, ...(filters.tagCategoryIds || [])]);
};
